import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ba16f8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-title" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "wrapper-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "popUp",
    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
  }, [
    _createElementVNode("div", {
      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
      class: "wrapper"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$localize('group.settings.delete.group')), 1),
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$localize('group.settings.delete.group.warning')), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
          class: "btn btn-cancel"
        }, _toDisplayString(_ctx.$localize('group.settings.leave.popup.cancellation')), 1),
        _createElementVNode("a", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('delete'))),
          class: "btn btn-logout"
        }, _toDisplayString(_ctx.$localize('group.settings.delete.button.group')), 1)
      ])
    ])
  ]))
}